import React from 'react';
import { Image, StyleSheet, View } from 'react-native';
import { AppView, rem } from 'design-system';
import StatusBar from 'design-system/StatusBar';
import Text from 'design-system/Text';
import withAnimatedNavigationHeader from 'design-system/hoc/withAnimatedNavigationHeader';
import Animated, { useAnimatedScrollHandler } from 'react-native-reanimated';
import { useMarginBottom } from 'hooks/useMarginBottom';
import QuoteInformation from '../components/QuoteInformation';
const info = 'This is how much we think you’ll pay over the next 12 months. We calculate an estimate of your future energy costs based on your current tariff and if you were to do nothing, meaning you’d end up on your current supplier’s cheapest relevant variable tariff';
const infotwo = 'If you switch before the end of your tariff you may incur an exit fee with your current provider, which isn’t included in your projected savings figures.';
const PersonalProjectionScreen = withAnimatedNavigationHeader(({ route, scrollY }) => {
    const { personalProjection } = route.params;
    const renderGas = () => {
        const { existingTariff } = personalProjection;
        const gas = existingTariff?.gas;
        if (!gas || !gas.current)
            return null;
        return (<View>
            <Text Text-14>Gas</Text>
            <QuoteInformation title="Current gas personal projection" text={`£${gas.projectedCost}`}/>
            <QuoteInformation title={`${gas.current.daysRemaining} on ${gas.current.name}`} text={`£${gas.current.cost}`}/>
          </View>);
    };
    const renderElectricity = () => {
        const { existingTariff } = personalProjection;
        const electricity = existingTariff?.electricity;
        if (!electricity || !electricity.current)
            return null;
        return (<View>
            <Text Text-14 style={styles.detailsTitle}>
              Electricity
            </Text>
            <QuoteInformation title="Current electricity personal projection" text={`£${electricity.projectedCost}`}/>
            <QuoteInformation title={`${electricity.current.daysRemaining} on ${electricity.current.name}`} text={`£${electricity.current.cost}`}/>
          </View>);
    };
    const scrollHandler = useAnimatedScrollHandler((handle) => {
        // eslint-disable-next-line no-param-reassign
        scrollY.value = handle.contentOffset.y;
    });
    const paddingBottom = useMarginBottom('paddingBottom', undefined, styles.contentContainerStyle);
    const { summary, cheapestTariff, existingTariff } = personalProjection;
    return (<AppView type="primary">
          <StatusBar barStyle="dark-content" animated/>
          <Animated.ScrollView onScroll={scrollHandler} scrollEventThrottle={16} style={styles.content} contentContainerStyle={paddingBottom}>
            <Text TextThin-14 style={styles.info}>
              {info}
            </Text>
            <Text TextThin-14 style={styles.info}>
              {infotwo}
            </Text>
            {summary !== undefined && (<>
                <QuoteInformation title={'If you don’t switch you’ll pay'} text={`£${summary.costOfExistingTariff}`}/>
                <QuoteInformation title="Switch today and you could pay" text={`£${summary.costOfCheapestTariff}`}/>
                <QuoteInformation title="Savings" text={`£${summary.potentialSavings}`}/>
              </>)}
            {(existingTariff?.electricity !== undefined ||
            existingTariff?.gas !== undefined) && (<>
                <Text Text-16 style={styles.detailsTitle}>
                  Your current personal projection
                </Text>
                {renderGas()}
                {renderElectricity()}
              </>)}
            {cheapestTariff !== undefined && (<>
                <Text Text-16 style={styles.detailsTitle}>
                  Cheapest personal projection
                </Text>
                <QuoteInformation title={cheapestTariff.details?.exitFee} text={`£${cheapestTariff.projectedCost || 0}`}/>
                <Text Text-16 style={styles.detailsTitle}>
                  Early Exit Fees
                </Text>
                <QuoteInformation title={cheapestTariff?.details?.name} text={`£${cheapestTariff?.details?.exitFee || 0}`}/>
              </>)}
            <Text Text-14 Gray-70 centered style={styles.footer}>
              No fee is payable if you switch within 50 days of your tariff end
              date
            </Text>
            <Image source={require('../../img/MSM.png')} style={styles.msmImage} resizeMode="contain"/>
          </Animated.ScrollView>
        </AppView>);
}, ({ colors }) => ({
    title: 'Personal Projection',
    headerColorOutputRange: [
        colors.background.light,
        colors.cards.onDark,
    ],
}));
const styles = StyleSheet.create({
    content: {
        flex: 1,
    },
    contentContainerStyle: {
        paddingTop: rem(20),
        paddingHorizontal: rem(20),
    },
    info: {
        marginBottom: rem(16),
    },
    detailsTitle: {
        marginTop: rem(16),
        marginBottom: rem(8),
    },
    footer: {
        marginTop: rem(20),
        marginBottom: rem(20),
    },
    msmImage: {
        tintColor: 'rgba(48,53,57, 0.5)',
        width: 100,
        height: 80,
        alignSelf: 'center',
    },
});
export default PersonalProjectionScreen;
